import { BtnDefault } from "@/components/Button";
import { useResetPassword } from "@/hooks/Auth";
import { ViewIcon, ViewOffIcon } from "@chakra-ui/icons";
import {
  Alert,
  AlertDescription,
  AlertIcon,
  AlertTitle,
  Button,
  Flex,
  IconButton,
  Img,
  Input,
  InputGroup,
  InputRightElement,
  Text,
  useToast
} from "@chakra-ui/react";
import Router from "next/router";
import { useState } from "react";
import { BsFileXFill } from "react-icons/bs";

function CardNewPassword() {
  const [Email, setEmail] = useState(null);
  const [Code, setCode] = useState(null);
  const [Password, setPassword] = useState(null);
  const [ConfirmPassword, setConfirmPassword] = useState(null);
  const [IsLoading, setIsLoading] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const toast = useToast({
    position: "bottom",
    duration: 5000,
    isClosable: true
  });

  const handleNewPasswordClick = () => setShowNewPassword(!showNewPassword);
  const handleConfirmPasswordClick = () => setShowConfirmPassword(!showConfirmPassword);

  const HandleSubmit = async (e) => {
    setIsLoading(true);
    e.preventDefault();
    e.stopPropagation();
    toast.closeAll();
    if (Password.length < 6) {
      setIsLoading(false);
      toast({
        title: "Senha muito curta",
        description: "A senha deve ter no mínimo 6 caracteres",
        status: "error"
      });
      return;
    }
    if (Password !== ConfirmPassword) {
      setIsLoading(false);
      toast({
        title: "Senhas não conferem",
        status: "error"
      });
      return;
    }
    const { code, email } = Router.query;

    const [UpPassData, UpPassError, UpPassLoading] = await useResetPassword({
      code: code as string,
      email: email as string,
      password: Password,
      site: "LINGLONG"
    });

    toast.closeAll();
    if (UpPassError !== null && UpPassData === null) {
      setIsLoading(false);

      if (UpPassError === "Code: InvalidToken, message: Invalid token.") {
        toast({
          title: "Não foi possível redefinir a senha!",
          description:
            "Houve um problema ao redefinir a senha. Entre em contato com nosso setor de atendimento - (41) 4042-1212",
          status: "error"
        });
      } else {
        toast({
          title: "Não foi possível redefinir a senha!",
          description: UpPassError,
          status: "error"
        });
      }

      // return Router.push('/')
    } else {
      setIsLoading(false);
      toast({
        title: "Senha alterada com sucesso",
        description: "Você será redirecionado para a página de login",
        status: "success",
        onCloseComplete: () => {
          Router.push("/login");
        }
      });
    }
  };

  return (
    <Flex w="full" justifyContent="center">
      <Flex
        w={["90%", "500px"]}
        h={"auto"}
        border={"1px solid"}
        borderColor={"ll-gray.100"}
        justifyContent={"center"}
        py={"25px"}
        bgColor={"ll-white.main"}
        borderRadius={"25px"}
        mt={["100px", "0px"]}
      >
        <Flex
          width={["90%", "25rem"]}
          direction="column"
          alignItems="center"
          as="form"
          onSubmit={HandleSubmit}
        >
          <Flex
            bgColor={"#FFCB05"}
            border="#ffc723 1px solid"
            borderRadius={["20px", "100px"]}
            flexDir={"column"}
            alignItems={"center"}
            w={"full"}
            mb={"25px"}
            px={"15px"}
            py={["20px", "15px"]}
            color={"ll-white.main"}
            textAlign={"center"}
          >
            <Flex direction="row" mb={"5px"} alignItems={"center"}>
              <Img
                mr={["10px", "15px"]}
                maxW="22px"
                maxH="22px"
                src="https://cdn.pneufree.com.br/LINGLONG/images/Geral/atention.svg"
                alt="ALERT"
              />
              <Text fontSize={"h4"} fontWeight={"500"}>
                Redefinição de senha
              </Text>
            </Flex>
            <Text fontSize={"text1"}>Digite uma nova senha para sua conta.</Text>
            <Text fontSize={"text1"}>
              Token expira em: <span style={{ fontWeight: "600" }}>5 minutos</span>
            </Text>
          </Flex>

          <InputGroup>
            <Input
              fontWeight={"500"}
              bgColor={"ll-gray.600"}
              fontSize={"text1"}
              border="1px solid"
              borderColor="ll-gray.100"
              borderRadius={"50px"}
              _placeholder={{ color: "gray.300" }}
              _hover={{ border: "1px solid #0C4EA2" }}
              _focus={{
                boxShadow: "none"
              }}
              name="password"
              id={"ResetPassword"}
              type={showNewPassword ? "text" : "password"}
              placeholder="Nova Senha"
              value={Password}
              isDisabled={IsLoading}
              onChange={(e) => setPassword(e.target.value)}
            />
            <InputRightElement>
              <IconButton
                color="gray"
                variant="outline'"
                icon={showNewPassword ? <ViewOffIcon /> : <ViewIcon />}
                onClick={handleNewPasswordClick}
                aria-label={"Password Icon"}
              />
            </InputRightElement>
          </InputGroup>

          <InputGroup mt={"10px"}>
            <Input
              fontWeight={"500"}
              bgColor={"ll-gray.600"}
              fontSize={"text1"}
              border="1px solid"
              borderColor="ll-gray.100"
              borderRadius={"50px"}
              _placeholder={{ color: "gray.300" }}
              _hover={{ border: "1px solid #0C4EA2" }}
              _focus={{
                boxShadow: "none"
              }}
              name="confirmPassword"
              id={"ResetConfirmPassword"}
              type={showConfirmPassword ? "text" : "password"}
              placeholder="Confirmar Nova Senha"
              value={ConfirmPassword}
              isDisabled={IsLoading}
              onChange={(e) => setConfirmPassword(e.target.value)}
              w="full"
            />
            <InputRightElement>
              <IconButton
                color="gray"
                variant="outline'"
                icon={showConfirmPassword ? <ViewOffIcon /> : <ViewIcon />}
                onClick={handleConfirmPasswordClick}
                aria-label={"Password Icon"}
              />
            </InputRightElement>
          </InputGroup>

          <Button
            variant={"primary-button"}
            mt={"25px"}
            w="full"
            type="submit"
            loadingText="Enviando..."
            isLoading={IsLoading}
            _hover={{ opacity: "0.5" }}
          >
            <Text textStyle="Bold">CONFIRMAR</Text>
          </Button>
        </Flex>
      </Flex>
    </Flex>
  );
}

export { CardNewPassword };
